<template>
  <template  v-if="this.$store.state.vModeWeek == 0">
    <div class="column " >
      <span class="date">
        {{dateFormat}}
        <div class="text-muted">{{dateFormatDayShort}}</div>
      </span>
    </div>
  </template>
  <template  v-if="this.$store.state.vModeWeek == 1">
    <div class="column vertical" >
      <span class="date">
        {{dateFormat}}
        <div class="text-muted">{{dateFormatDayShort}}</div>
      </span>
    </div>
  </template>
</template>
<style scoped>
.column{
  display: flex;
  width: calc(100% / 7);
  container-type: inline-size;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #fff8da;
  border-radius: 5px;
  margin-left:1px;
  container-name: columnn-container;
  container-type: inline-size;

}
.column.vertical{
  width: 100%;
  flex-direction: column;
  margin-left:0px;
  margin-bottom:1px;
  background: #eee;
}
@container columnn-container (max-width: 1000px) {
  .date{
    display: flex;
    height: 100cqw;
    font-size: 20cqw;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}


</style>
<script>

export default {
  name: "CabCardMobile",
  props: {
    date: String
  },
  data() {
    return {
      daysTitle:[
        'воскресенье',
        'понедельник',
        'вторник',
        'среда',
        'четверг',
        'пятница',
        'суббота'
      ],
      daysTitleShort:[
        'вс',
        'ПН',
        'ВТ',
        'СР',
        'ЧТ',
        'ПТ',
        'СБ'
      ],
    }
  },
  created() {

  },
  computed: {
    dateFormat(){
      let stamp = Date.parse(this.date)
      let date = new Date(stamp)
      var dd = date.getDate();
      if (dd < 10) dd = '0' + dd;

      var mm = date.getMonth() + 1;
      if (mm < 10) mm = '0' + mm;

      var yy = date.getFullYear().toString().substr(2,2); //% 100;
      // if (yy < 10) yy = '0' + yy;

      return dd + '.' + mm + '.' + yy;
    },
    dateFormatDay(){
      let date = new Date(this.date)
      let dayNum = date.getDay()
      return this.daysTitle[dayNum]
    },
    dateFormatDayShort(){
      let date = new Date(this.date)
      let dayNum = date.getDay()
      return this.daysTitleShort[dayNum]
    }
  },
  methods: {

  }
}
</script>

